import React from 'react';
import { useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Alert from 'react-bootstrap/Alert';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import User from '../users/User.js';

export default function Show() {
  const { id } = useParams();
  const { isLoading, error, data } = useQuery(['users', id], () => User.show(id), {
    placeholderData: {
      id: '',
      name: '',
      created_at: '',
      updated_at: ''
    }
  })

  return (
    <Container>
      {isLoading && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='info'>
              Loading...
            </Alert>
          </Col>
        </Row>
        )}
      {error && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='danger'>
              {error}
            </Alert>
          </Col>
        </Row>
      )}
      <Row className='pt-3'>
        <h1 className='display-6'>User</h1>
        <Col>
          <FloatingLabel label="Name" className="mb-3">
            <Form.Control disabled type="text" value={data.name} />
          </FloatingLabel>
        </Col>
      </Row>
      <Row>
        <Col>
          <FloatingLabel label="Created" className="mb-3">
            <Form.Control disabled type="text" value={data.created_at} />
          </FloatingLabel>
        </Col>
      </Row>
      <Row>
        <Col>
          <FloatingLabel label="Updated" className="mb-3">
            <Form.Control disabled type="text" value={data.updated_at} />
          </FloatingLabel>
        </Col>
      </Row>
      <Row>
        <Col>
          <Link to={`/users`} className="btn">
            Back to list
          </Link>
        </Col>
      </Row>
    </Container>
  )
}